import { graphql } from 'src/gql'
import { ReportBuilderQueryVariables } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query reportBuilder ($model: String!, $match: JSON, $pipeline: [JSON]) {
    cat {
      reporting {
        builder {
          aggregate(model: $model, match: $match, pipeline: $pipeline) {
            results
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type ReportBuilderResults = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['reporting']>['builder']>['aggregate']

const useReportBuilder = (variables?: ReportBuilderQueryVariables): ReportBuilderResults => {
  const { data } = useGraphQL(document, variables, {
    enabled: variables !== undefined
  })
  return data?.cat?.reporting?.builder?.aggregate
}

export { useReportBuilder, document as reportBuilderDocument }
